import React from "react";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import { AppButton } from "../Generic/AppButton";
import { AppOverlay } from "../Generic/AppOverlay";
import { IsDefined } from "../Generic/IsDefined";

export interface PromptBottomSheetOption {
  value: any;
  label: string;
}

interface Props {
  title: string;
  message?: string;
  options: PromptBottomSheetOption[];
  isOpen: boolean;
  onChoose: (value: any) => void;
  onRequestClose: () => void;
}

const PromptBottomSheet = (props: Props) => {
  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={props.isOpen}
        className="PromptBottomSheet"
        title={props.title}
        rounded={true}
        onRequestClose={props.onRequestClose}
      >
        <IsDefined value={props.message}>
          {(_message) => <span className="_message">{_message}</span>}
        </IsDefined>
        <div className="_options">
          {props.options.map((option) => (
            <AppButton
              key={option.value}
              variant="outline"
              onClick={() => props.onChoose(option.value)}
            >
              {option.label}
            </AppButton>
          ))}
        </div>
      </AppBottomSheet>
    </AppOverlay>
  );
};

export default React.memo(PromptBottomSheet);
